/*** IMPORTS FROM imports-loader ***/
var global = window;

export const notInitialized = () => {
  throw new Error('uSES not initialized!');
};
